export default __webpack_public_path__ + "static/media/B63.7e69c738.png";